import apiUrl from '../../../../../constants';
import axios from 'axios';
import CryptoJS from 'crypto-js';
import Paginate from 'vuejs-paginate';
//import VueElementLoading from 'vue-element-loading';
import {BasicSelect,  MultiSelect} from 'vue-search-select'
import vueMultiSelect from 'vue-multi-select';
import 'vue-multi-select/dist/lib/vue-multi-select.css';
import MasterService from './../../../../masterdata/services/masterdata.service';
import Loader from '../../../../shared/components/loader'
import AdminSettingsService from './../../../services/adminsettings.service';

export default {
  name: 'createODApincode',
  props:
    ['selectedODApincode'],

  components: {
    //VueElementLoading,
    Paginate,
    BasicSelect,
    vueMultiSelect,
    Loader
  },
  data: function() {
    return {
      updateID: '',
      servicepincode: '',
      isLoading:false,
      regionlist: [],
      selectedregion: {
        text: '',
        value: ''
      },
      region: '',
      statelist: [],
      selectedstate: {
        text: '',
        value: ''
      },
      state: '',
      citylist: [],
      selectedcity: {
        text: '',
        value: ''
      },
      city: '',
      pincodetype: '',
      pincodekmsfrombranch: '',
    }
  },
  computed: {

  },
  mounted() {
    var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.getRegionList();
    this.getStateList();
    this.userName = userdetail.email;
    if(this.selectedODApincode){
      this.updateID = this.selectedODApincode.id;
      this.servicepincode=this.selectedODApincode.servicepincode;
      this.pincodetype = this.selectedODApincode.pincodetype;
      this.pincodekmsfrombranch = this.selectedODApincode.pincodekmsfrombranch;
      this.selectedcity.text = this.selectedODApincode.city;
      this.selectedregion.text = this.selectedODApincode.region;
      this.selectedstate.text = this.selectedODApincode.state;
      this.region = this.selectedregion.text
      this.city = this.selectedcity.text
      this.state = this.selectedstate.text
    } else {
      this.updateID="";
      this.servicepincode = "";
      this.pincodetype = "";
      this.pincodekmsfrombranch = "";
      this.selectedcity.text = "";
      this.city = "";
      this.selectedstate.text = "";
      this.state = "";
      this.selectedregion.text = "";
      this.region = "";
    }

  },
  methods: {
    selectRegion(selectedregion) {
      this.selectedregion = selectedregion
      this.region = selectedregion.text
    },
    showCreateODAPincode() {
      this.$emit("goBackToParent")
    },
    async getRegionList() {
      var regionlist = []
      try {
        this.isLoading = true;
        let result = await MasterService.getRegionList()
        this.isLoading = false;
        regionlist = result.data.data
        for (var i = 0; i < regionlist.length; i++) {
          this.regionlist.push({
            'text': regionlist[i].region
          })
        }
      } catch (err) {
        console.log(err);
      }
    },
    async getStateList() {
      var stateregionlist = []
      try {
        this.isLoading = true;
        let result = await MasterService.getStateList()
        this.isLoading = false;
        stateregionlist = result.data.data
        for (var i = 0; i < stateregionlist.length; i++) {
          this.statelist.push({
            'value': stateregionlist[i].stateid,
            'text': stateregionlist[i].statename
          })
        }
      } catch (err) {
        console.log(err);
      }
    },
    selectState(selectedstate) {
      this.selectedstate = selectedstate
      this.state = selectedstate.text
      this.citylist = []
      this.selectedcity = {
        text: '',
        value: ''
      }
      this.city = ''
      if (this.state != '') {
        this.getCityList(selectedstate.value)
      }
    },
    async getCityList(stateid) {
      var citystateregionlist = []
      try {
        this.isLoading = true;
        let inputPayload = {
          "stateId": [stateid]
        }
        let result = await MasterService.getCityList(inputPayload)
        this.isLoading = false;
        citystateregionlist = result.data.data
        for (var i = 0; i < citystateregionlist.length; i++) {
          this.citylist.push({
            'value': citystateregionlist[i].cityid,
            'text': citystateregionlist[i].cityname
          })
        }
      } catch (err) {
        console.log(err);
      }
    },
    selectCity(selectedcity) {
      this.selectedcity = selectedcity
      this.city = selectedcity.text
    },
    async createODAPincode(){
      try {
        var inputPayload = {};
        this.isLoading = true;
        if(this.updateID){
          inputPayload.id = this.updateID;
        }
        inputPayload.servicepincode = this.servicepincode,
        inputPayload.pincodetype = this.pincodetype,
        inputPayload.pincodekmsfrombranch = this.pincodekmsfrombranch,
        inputPayload.state = this.state,
        inputPayload.city = this.city,
        inputPayload.region = this.region
        inputPayload.status = 1
        let result = await AdminSettingsService.createODAPincode(inputPayload);
        this.isLoading = false;
        if (result.data.code == 200) {
          this.$alert(result.data.message, this.serviceAreaName, "success");
          this.$emit("goBackToParent");
        }else{
          this.$alert(result.data.message, this.serviceAreaName, "error");
        }
      } catch(err){
        this.isLoading = false;
        this.$alert(err, this.serviceAreaName, "error");
        console.log(err);
      }
    },
    onSubmit: function(event) {
      this.$validator.validateAll().then((result) => {
        if(result){
          this.createODAPincode(event);
        }
      }).catch(() => {
        console.log('errors exist', this.errors)
      });
    },
  }
}



// WEBPACK FOOTER //
// ./src/modules/adminsettings/views/odapincodemaster/Createodapincode/Createodapincode.component.js